export default {
  en: {
    networkError: 'Could not connect to the server ({{url}}): {{reason}}',
    timeoutError: 'The server did not respond in time ({{url}})',
    authError: 'Telegram could not confirm your login. Reopen the mini app from the bot.',
    serverError: 'Server responded with an error {{status}}',
  },
  ru: {
    networkError: 'Не удалось подключиться к серверу ({{url}}): {{reason}}',
    timeoutError: 'Сервер не ответил вовремя ({{url}})',
    authError: 'Telegram не подтвердил вход. Открой мини-апп заново из бота.',
    serverError: 'Сервер ответил ошибкой {{status}}',
  },
  de: {
    networkError: 'Verbindung zum Server fehlgeschlagen ({{url}}): {{reason}}',
    timeoutError: 'Der Server hat nicht rechtzeitig geantwortet ({{url}})',
    authError: 'Telegram konnte deine Anmeldung nicht bestätigen. Öffne die Mini-App erneut über den Bot.',
    serverError: 'Der Server hat mit einem Fehler geantwortet {{status}}',
  },
  pt: {
    networkError: 'Não foi possível conectar ao servidor ({{url}}): {{reason}}',
    timeoutError: 'O servidor não respondeu a tempo ({{url}})',
    authError: 'O Telegram não confirmou seu login. Abra o mini app novamente pelo bot.',
    serverError: 'O servidor respondeu com um erro {{status}}',
  },
  fr: {
    networkError: 'Impossible de se connecter au serveur ({{url}}) : {{reason}}',
    timeoutError: 'Le serveur n’a pas répondu à temps ({{url}})',
    authError: 'Telegram n’a pas pu confirmer ta connexion. Rouvre la mini-app depuis le bot.',
    serverError: 'Le serveur a répondu avec une erreur {{status}}',
  },
  es: {
    networkError: 'No se pudo conectar al servidor ({{url}}): {{reason}}',
    timeoutError: 'El servidor no respondió a tiempo ({{url}})',
    authError: 'Telegram no pudo confirmar tu inicio de sesión. Abre la mini app de nuevo desde el bot.',
    serverError: 'El servidor respondió con un error {{status}}',
  },
};
